import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './charte/Elements';
import { idMission, Mission } from '../donnees/missions';
import { Situation } from '../donnees/situation';
import { COULEURS, texteSurClair } from '../theme/charte';

/* Liste des missions en grille, d'après les maquettes Accueil et Missions :
   mission (titre et détail), statut, avancement, prochaine étape, livraison.
   Chaque ligne mène à la mission, ou au devis quand il attend la signature. */

const COLONNES = {
  accueil: 'minmax(0, 2.2fr) minmax(0, 1.2fr) minmax(0, 1.6fr) minmax(0, 1.2fr) minmax(0, 0.9fr)',
  missions: 'minmax(0, 2.4fr) minmax(0, 1.2fr) minmax(0, 1.5fr) minmax(0, 1.4fr) minmax(0, 0.9fr)',
};

export const Avancement: React.FC<{ situation: Situation }> = ({ situation }) => (
  <div className="avancement">
    <div className="progression" role={situation.pourcentage != null ? 'progressbar' : undefined}
      aria-valuemin={situation.pourcentage != null ? 0 : undefined} aria-valuemax={situation.pourcentage != null ? 100 : undefined}
      aria-valuenow={situation.pourcentage ?? undefined} aria-label={situation.pourcentage != null ? 'Avancement de la collecte' : undefined}>
      {situation.pourcentage != null && (
        <div className="progression__barre" style={{ width: `${situation.pourcentage}%`, background: situation.couleurBarre }} />
      )}
    </div>
    <div className="avancement__texte">{situation.avancementTexte}</div>
  </div>
);

const ListeMissions: React.FC<{
  lignes: { mission: Mission; situation: Situation }[];
  variante: 'accueil' | 'missions';
  vide?: React.ReactNode;
}> = ({ lignes, variante, vide }) => {
  const style = { '--colonnes': COLONNES[variante] } as React.CSSProperties;
  return (
    <div className="liste" style={style}>
      <div className="liste__entete" aria-hidden>
        <div>Mission</div><div>Statut</div><div>Avancement</div><div>Prochaine étape</div><div>Livraison</div>
      </div>
      {lignes.length === 0 ? (
        <div className="liste__vide">{vide ?? 'Aucune mission.'}</div>
      ) : lignes.map(({ mission, situation }) => {
        const etape = situation.etape;
        const bouton = variante === 'missions' && etape.action;
        return (
          <Link key={idMission(mission)} to={situation.lien} data-testid={`mission-${idMission(mission)}`}
            className={`liste__ligne${bouton ? ' liste__ligne--action' : ''}`}>
            <div className="liste__principal">
              <div className="liste__titre">{mission.titre || 'Mission sans titre'}</div>
              {situation.detail && <div className="liste__detail">{situation.detail}</div>}
            </div>
            <div data-label="Statut"><Badge libelle={situation.statut.libelle} couleur={situation.statut.couleur} /></div>
            <div data-label="Avancement"><Avancement situation={situation} /></div>
            <div data-label="Prochaine étape">
              {bouton ? (
                <span className="bouton bouton--petit" style={{ fontSize: '14px', padding: '8px 14px' }}>{etape.texte}</span>
              ) : (
                <span style={{ fontSize: '14px', color: texteSurClair(etape.couleur), fontWeight: etape.couleur === COULEURS.texteSecondaire ? 400 : 600 }}>
                  {etape.texte}
                </span>
              )}
            </div>
            <div data-label="Livraison" style={{ fontSize: '14px', color: situation.livraison === '—' ? COULEURS.texteDiscret : undefined }}>
              {situation.livraison}
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default ListeMissions;
